<template>
    <div class="studio_nav_content">
        <div class="page-mode">
            <!-- 搜索条件 -->
            <div class="form-box">
                <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                         @submit.native.prevent="handleQuery">
                    <el-row class="mt15">
                        <el-col :span="6" class="mb0">
                            <el-form-item label="关注类型">
                                <el-select clearable @change="getList" v-model="queryParams.groupNature" placeholder="请选择">
                                    <el-option :label="'名师工作室'" :value="2" />
                                    <el-option :label="'名校长工作室'" :value="3" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10" class="mb0">
                        </el-col>
                        <el-col :span="8" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.groupName" placeholder="请输入工作室名称" class="input-with-select">
                                    <template #append>
                                        <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!-- 关注列表 -->
            <div class="list-container" v-loading="loading">
                <div class="studio-list">
                    <div class="studio-item" v-for="(item, index) in dataList" :key="index" @click="goPage(item)">
                        <img class="studio-avatar" :src="item.groupAvatar" alt="">
                        <div class="studio-text">
                            <div class="studio-name" :title="item.groupName">{{ item.groupName }}</div>
                            <div class="studio-nature">{{ item.groupNatureName }}</div>
                            <div class="studio-btn" @click.stop="getstudioCareOrCancel(item)">取消关注</div>
                        </div>
                    </div>
                </div>
                <el-empty style="margin: 0 auto;padding-top: 10vh;" v-if="dataList.length == 0" :image-size="200" />
            </div>
        </div>
    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import { queryDict } from "@/api/admin/public";
import { userCareStudio } from "@/api/admin/system";
import { studioCareOrCancel } from "@/api/admin/studio";

export default {
    name: "scenarioMain",
    components: {
    },
    data() {
        return {
            subjectList: [],
            periodList: [],
            gradeList: [],
            gAFileList: [],
            token: this.$storage.get("token"),
            roleList: [
                { name: '已参与', value: 1 },
                { name: '未参与', value: 2 },
            ],
            timestampToTime,
            // 遮罩层
            loading: true,
            // 选中数组
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            isFilter: true,
            // 总条数
            total: 0,
            taskdata: {},
            // 基础：基数数据表格数据
            dataList: [
                // {
                //     did: 1,
                //     title: 'cs',
                //     values: '1222'
                // }
            ],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                groupNature: '',
                groupName: '',
            },
            courseClassifyList:[],
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" }
                ],
                values: [
                    { required: true, message: "请输入内容", trigger: "blur" }
                ]
            },
            selectObj: []
        };
    },
    created() {
        this.getQueryDict()
        this.getList();
    },
    activated() {
        // console.log('fdssfd',this.$route.query.isSx)
        if (this.$route.query.isSx == 1) {
            this.getList();
        }
    },
    watch: {
        $route(to, from) {
            console.log('to', to)
        },
    },
    methods: {
        goPage(item) {

            let path = 'teachStudioHome';
            if (item.groupNature==='3'){
                path = 'rectorStudioHome';
            }
            //参数传递
            this.$store.commit("params/setJumpParams",
              {activePath:path,activeItem: '2',studioId:item.groupId,studioNature:item.groupNature});
            this.$router.push({path: "/jzedu/studiodetail"});

        },
        getstudioCareOrCancel(row) {
            studioCareOrCancel({ groupId: row.groupId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success('取消成功')
                    this.getList();
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'famous_course_classify' }).then(res => {
                this.courseClassifyList = res.data.data;
            })
        },
        /** 查询基础：基数数据列表 */
        getList() {
            userCareStudio().then(res => {
                if (this.queryParams.groupNature) {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.groupNature == this.queryParams.groupNature
                    })
                }
                if (this.queryParams.groupName) {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.groupName.toString().indexOf(this.queryParams.groupName) != -1
                    })
                }
                this.dataList = res.data.data;
                this.loading = false;
            });
        },
        goDetail(row) {
            this.$router.push({
                path: "/lessonDetail",
                query: {
                    lessonId: row.lessonId,
                }
            });
        },
        // 表单重置
        reset() {
            this.form = {
                did: null,
                type: null,
                title: null,
                values: null,
                px: null,
                createTime: null,
                updateTime: null,
                delFlag: null
            };
            // this.$refs['form'].resetFields()
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.$refs['queryForm'].resetFields()
            this.handleQuery();
        },
    }
};
</script>
<style scoped>
.studio_nav_content{
    width: 100%;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 182px);
    background-color: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
/* 搜索条件 */
.form-box{
    flex-shrink: 0;
    padding: 0 16px 14px;
    box-sizing: border-box;
    border-bottom: 1px solid #f0f0f0;
}
/* 列表 */
.list-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;
}
.studio-list{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}
.studio-item{
    display: flex;
    width: calc(33.33% - 11px);
    box-sizing: border-box;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    cursor: pointer;
    transition: box-shadow .2s;
}
.studio-item:hover{
    box-shadow: 0 2px 12px rgba(13, 85, 164, .12);
}
.studio-avatar{
    width: 96px;
    height: 96px;
    border-radius: 8px;
    object-fit: cover;
    flex-shrink: 0;
}
.studio-text{
    flex: 1;
    min-width: 0;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
}
.studio-name{
    font-size: 15px;
    font-weight: bold;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.studio-nature{
    margin-top: 8px;
    font-size: 13px;
    color: #999;
}
.studio-btn{
    margin-top: auto;
    width: fit-content;
    height: 26px;
    line-height: 24px;
    padding: 0 12px;
    box-sizing: border-box;
    font-size: 12px;
    color: #ff7f2e;
    border: 1px solid #ff7f2e;
    border-radius: 4px;
    cursor: pointer;
}
.studio-btn:hover{
    background: #ff7f2e;
    color: #fff;
}
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}
</style>
